export const categoryPageId = 'category-page';
